export type ConversationHistoryState = 'loading' | 'error' | null;

/**
 * Which history fetch, if any, the conversation on screen is waiting on.
 *
 * All three ids are null on an empty composer with nothing in flight, so
 * comparing them directly answers "loading" for a conversation that does not
 * exist — and since no request is running, nothing ever arrives to clear it.
 * Starting a new chat lands straight on a spinner that cannot finish.
 *
 * A draft has no stored history to fetch, which is what makes the absence of a
 * conversation an answer in itself rather than something to match against.
 */
export function resolveConversationHistoryState(
  currentSessionId: string | null,
  loadingSessionId: string | null,
  errorSessionId: string | null,
): ConversationHistoryState {
  if (!currentSessionId) return null;
  if (loadingSessionId === currentSessionId) return 'loading';
  if (errorSessionId === currentSessionId) return 'error';
  return null;
}
